// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"f90be7c9","461":"b773de2e","501":"84061551"}[chunkId] + ".chunk.js";
};